





















































































































































































































































































import PartnerReportDetailChangeProgress from "@/components/partner/PartnerReportDetailChangeProgress.vue";
import PartnerReportDetailInfoCard from "@/components/partner/PartnerReportDetailInfoCard.vue";
import PartnerReportDetailInfoTimeLineCard from "@/components/partner/PartnerReportDetailInfoTimeLineCard.vue";
import SendToExternOption from "@/components/partner/PartnerReportDetailSendToExternOption.vue";
import ContactCustomerDialog from "@/components/utility/ContactCustomerDialog.vue";
import { ContactCustomerEnum } from "@/lib/enum/ContactCustomer.enum";
import { detailedDate, simpleDate, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import ExportMixin from "@/mixins/XMLExportMixin.vue";
import { ReportEntity } from "@/models/reportEntity";
import {
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivPartnerMessageViewModelGen,
  MrfiktivReferenceGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ThgPartnerMessageViewModelGen } from "@/services/thg/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { ActivityLogModule, ActivityTypeEnum } from "@/store/modules/activity-log.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import { Ticket } from "@/store/modules/ticket.store";
import ReportDocumentSignRequestDialog from "@/views/sign/ReportDocumentSignRequestDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import TicketCreateDialog from "../project/TicketCreateDialog.vue";
import TemplateDialog from "../template/TemplateDialog.vue";
import CopyClipboardText from "../utility/CopyClipboardText.vue";
import Debug from "../utility/Debug.vue";
import TableWrapper from "../utility/TableWrapper.vue";
import PartnerReportDetailDeleteDialog from "./PartnerReportDetailDeleteDialog.vue";
import PartnerReportInitializeDialog from "./PartnerReportInitializeDialog.vue";
import PartnerReportUpdateReportDialog, { ReportUpdateTabEnum } from "./PartnerReportUpdateReportDialog.vue";
import ReportActivityShareDialog from "./ReportActivityShareDialog.vue";
import ReportActivityUploadDialog from "./ReportActivityUploadDialog.vue";
import Tooltip from "../utility/tooltip.vue";
import AssigneeUpdateMixin, { IAssigneeUpdateMixin } from "../project/AssigneeUpdateMixin.vue";

@Component({
  components: {
    CopyClipboardText,
    PartnerReportDetailInfoCard,
    PartnerReportDetailInfoTimeLineCard,
    PartnerReportDetailChangeProgress,
    PartnerReportDetailDeleteDialog,
    ContactCustomerDialog,
    SendToExternOption,
    ReportDocumentSignRequestDialog,
    TemplateDialog,
    TableWrapper,
    Debug,
    ReportActivityShareDialog,
    PartnerReportUpdateReportDialog,
    ReportActivityUploadDialog,
    PartnerReportInitializeDialog,
    TicketCreateDialog,
    Tooltip
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class PartnerReportDetail extends mixins(ExportMixin, PermissionMixin, AssigneeUpdateMixin)
  implements IAssigneeUpdateMixin {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  displayToDetailView!: boolean;

  @Prop({ default: false })
  showClose!: boolean;

  @Prop({ default: "calc(100vh - 165px)" })
  height!: string;

  isTicketCreateDialogActive = false;

  updateLoading = false;

  ticketRefs: MrfiktivReferenceGen[] = [];

  get assignees() {
    return this.report.assignees as string[];
  }

  set assignees(value: string[]) {
    const oldAssignees = this.assignees;
    const newAssignees = value;

    this.debounceChangeAssignees(newAssignees, oldAssignees, this.report.id || this.report._id);

    this.report.assignees = value;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get ReportUpdateTabEnum() {
    return ReportUpdateTabEnum;
  }

  get users() {
    return PartnerUserModule.paginationList;
  }

  get headlineName() {
    const name = this.report.customerName;
    const firmenname = this.report.companyName || "";

    if (firmenname) {
      return `${firmenname} (${name})`;
    } else {
      return name;
    }
  }

  get isTemplateActive() {
    return FeatureModule.isTemplateEnabled;
  }

  get isTimelineEnabled() {
    return FeatureModule.isReportEnabled.isTimelineEnabled;
  }

  get isSignEnabled() {
    return FeatureModule.isDigitalSignatureEnabled.isSignEnabled;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get reports() {
    return ReportPaginationModule.paginationList;
  }

  get reportsCount() {
    return ReportPaginationModule.totalItems;
  }

  get resource() {
    return ContactCustomerEnum.REPORT;
  }

  get numberOfImages() {
    return (
      PartnerModule?.report?.images?.cockpits.length +
      PartnerModule?.report?.images?.damages.length +
      PartnerModule?.report?.images?.damagesDetail.length +
      PartnerModule?.report?.images?.overviews.length
    );
  }

  get date() {
    if (PartnerModule.report?.timestamps?.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(PartnerModule.report?.timestamps?.created, locale);
    }
    return "Kein Datum";
  }

  get dateSimple() {
    if (PartnerModule.report?.timestamps?.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return simpleDate(PartnerModule.report?.timestamps?.created, locale);
    }
    return "";
  }

  get datePreference() {
    if (PartnerModule.report?.datePreference) {
      return simpleDate(PartnerModule.report?.datePreference);
    }
    return "";
  }

  get fahrzeugscheinImage() {
    if (this.report.images.registrations[0]) {
      return this.report.images.registrations[0].url;
    }
    return "";
  }

  get isUpdateProgressStatusEnabled() {
    return FeatureModule.isUpdateProgressStatusEnabled;
  }

  get activityLog() {
    return ActivityLogModule.paginationList;
  }

  get headers() {
    return [
      { text: this.$t("partner.ActivityLogTable.timestamp"), align: "start", value: "timestamp.created", width: 100 },
      { text: this.$t("partner.ActivityLogTable.userName"), align: "start", value: "user.userName" },
      { text: this.$t("partner.ActivityLogTable.actionType.title"), align: "start", value: "actionType", width: 100 },
      { text: this.$t("partner.ActivityLogTable.activity"), align: "start", value: "activity", width: 100 },
      { text: this.$t("partner.ActivityLogTable.comment"), align: "start", value: "comment" },
      { text: "", align: "end", value: "controls", width: 200, sortable: false }
    ];
  }

  get isDownloadKsrExportEnabled() {
    return true;
  }

  @Watch("report.id")
  @Watch("report._id")
  @Watch("report.vehicleId")
  setRefs() {
    this.ticketRefs.splice(0);

    if (this.report._id ?? this.report.id) {
      this.ticketRefs.push({
        refType: BackendResourceEnum.REPORT,
        refId: this.report._id ?? this.report.id
      });
    }

    if (this.report.vehicleId) {
      this.ticketRefs.push({
        refType: BackendResourceEnum.VEHICLE,
        refId: this.report.vehicleId
      });
    }
  }

  showSignDialog() {
    (this.$refs.signDialog as ReportDocumentSignRequestDialog).show();
  }

  showEmailDialog() {
    (this.$refs.templateDialog as TemplateDialog).show();
  }

  showShareDialog() {
    (this.$refs.shareDialog as ReportActivityShareDialog).show();
  }

  showUploadDialog() {
    (this.$refs.uploadDialog as ReportActivityUploadDialog).show();
  }

  showTicketDialog() {
    (this.$refs.ticketDialog as TicketCreateDialog).startDialog();
  }

  toDetailView() {
    this.$router.push({
      name: "PartnerReportsDetailView",
      params: { reportId: PartnerModule.report._id, partnerId: PartnerModule.report.partnerId }
    });
  }

  async downloadExport(type: "ksr" | "dealerdesk") {
    this.downloadReportExport(type, this.report);
  }

  /**
   * Set the active entry to the newest entry in the entries available.
   */
  async setToLatestEntry() {
    if (ReportPaginationModule.paginationList) {
      this.$emit("setReport", ReportPaginationModule.paginationList[0]);
    }
  }

  get templateDialogMethods() {
    return {
      context: {
        partner: this.partner,
        report: this.report
      },
      to: [this.report.customerContact?.email || ""],
      from: [this.partner]
    };
  }

  async onTicketCreated(ticket: Ticket) {
    if (!ticket.id) {
      return;
    }

    try {
      const created = await ActivityLogModule.create({
        partnerId: this.partner.id,
        data: {
          target: [{ refType: BackendResourceEnum.TICKET, refId: ticket.id }],
          actionType: ActionEnum.CREATE,
          activity: ActivityTypeEnum.CREATE_TICKET,
          source: {
            refType: BackendResourceEnum.REPORT,
            refId: this.report._id
          }
        }
      });

      ActivityLogModule.addToList(created);
    } catch (e) {
      this.$log.error(e);
    }
  }

  async sent(messages: MrfiktivPartnerMessageViewModelGen[] | ThgPartnerMessageViewModelGen[] | undefined) {
    if (!messages || messages.length <= 0) {
      return;
    }

    for (const message of messages) {
      const source: MrfiktivReferenceGen = {
        refType: BackendResourceEnum.REPORT,
        refId: this.report._id
      };
      const data: MrfiktivCreateActivityLogDtoGen = {
        source,
        target: [{ refType: BackendResourceEnum.MESSAGE, refId: message.id }],
        actionType: ActionEnum.CREATE,
        activity: ActivityTypeEnum.MESSAGE
      };

      const activity = await ActivityLogModule.create({
        partnerId: this.partner.id,
        data
      }).catch(handleError);

      if (activity) {
        ActivityLogModule.addToList(activity);
      }
    }
  }

  setReport(report: ReportEntity) {
    this.$emit("setReport", report);
  }

  /**
   * @override
   * @param added
   * @param removed
   */
  async changeAssignees(added: string[], removed: string[], all: string[], documentId: string) {
    try {
      this.updateLoading = true;

      const source = {
        refType: BackendResourceEnum.REPORT,
        refId: documentId
      };

      const partnerId = this.partner.id;

      await PartnerModule.updateReport({
        partnerId: this.report.partnerId,
        reportId: documentId,
        updateDto: { assignees: all }
      });

      const promises = [];
      if (removed.length > 0) {
        const promise = ActivityLogModule.createAssigneeActivity({
          partnerId,
          source,
          newAssignees: removed,
          activityType: ActivityTypeEnum.DELETE_ASSIGNEE
        });

        promises.push(promise);
      }
      if (added.length > 0) {
        const promise = ActivityLogModule.createAssigneeActivity({
          partnerId,
          source,
          newAssignees: added,
          activityType: ActivityTypeEnum.CREATE_ASSIGNEE
        });

        promises.push(promise);
      }

      await Promise.all(promises);
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.updateLoading = false;
    }
  }
}
